(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-showcase"] && !Shopify.designMode) return;
  try {
    
  class ShowcaseReveal extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-showcase-reveal]').forEach((comparison) => {
        const stage = comparison.querySelector('.campaign-showcase__stage');
        let dragging = false;
        const setValue = (value) => {
          const bounded = Math.max(4, Math.min(96, value));
          stage.style.setProperty('--reveal', `${bounded}%`);
          stage.setAttribute('aria-valuenow', String(Math.round(bounded)));
        };
        const update = (event) => {
          const bounds = stage.getBoundingClientRect();
          setValue(((event.clientX - bounds.left) / bounds.width) * 100);
        };
        stage.addEventListener('pointerdown', (event) => { dragging = true; stage.setPointerCapture(event.pointerId); update(event); });
        stage.addEventListener('pointermove', (event) => { if (dragging || event.pointerType === 'mouse') update(event); });
        stage.addEventListener('pointerup', () => { dragging = false; });
        stage.addEventListener('pointercancel', () => { dragging = false; });
        stage.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const current = Number(stage.getAttribute('aria-valuenow')) || 54;
          setValue(current + (event.key === 'ArrowRight' ? 4 : -4));
        });
      });
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }), { rootMargin: '0px 0px -8% 0px', threshold: .08 });
      this.closest('.campaign-showcase')?.querySelectorAll('[data-showcase-tile]').forEach((tile) => observer.observe(tile));
    }
  }
  if (!customElements.get('showcase-reveal')) customElements.define('showcase-reveal', ShowcaseReveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalog-hero"] && !Shopify.designMode) return;
  try {
    
  class CatalogHeroSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = [...this.querySelectorAll('[data-hero-card]')];
      if (this.cards.length < 2) return;
      this.activeIndex = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Number(this.dataset.interval) || 3000;
      this.status = this.querySelector('[data-hero-status]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelector('[data-hero-previous]')?.addEventListener('click', () => this.move(-1, true));
      this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.move(1, true));
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.start(); });
      this.addEventListener('pointerdown', (event) => { this.pointerStart = event.clientX; });
      this.addEventListener('pointerup', (event) => {
        if (this.pointerStart == null) return;
        const distance = event.clientX - this.pointerStart;
        this.pointerStart = null;
        if (Math.abs(distance) > 45) this.move(distance > 0 ? -1 : 1, true);
      });
      document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());
      this.reducedMotion.addEventListener('change', () => this.start());
      this.update(false);
      this.start();
    }

    move(direction, announce) {
      this.activeIndex = (this.activeIndex + direction + this.cards.length) % this.cards.length;
      this.update(announce);
      this.stop();
      this.start();
    }

    update(announce) {
      this.cards.forEach((card, index) => {
        const position = (index - this.activeIndex + this.cards.length) % this.cards.length;
        card.dataset.position = position;
        card.tabIndex = position === 0 ? 0 : -1;
      });
      if (announce && this.status) this.status.textContent = this.cards[this.activeIndex].textContent.trim();
    }

    start() {
      this.stop();
      if (!this.autoplay || this.reducedMotion.matches || document.hidden) return;
      this.timer = window.setInterval(() => this.move(1, false), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
    }
  }

  if (!customElements.get('catalog-hero-slider')) customElements.define('catalog-hero-slider', CatalogHeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-lead-capture"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lead-capture]').forEach((section) => {
    const dialog = section.querySelector('[data-lead-dialog]');
    if (!dialog || sessionStorage.getItem('pmb_lead_prompt_seen') === '1') return;
    let shown = false;
    const show = () => {
      if (shown || sessionStorage.getItem('pmb_lead_prompt_seen') === '1') return;
      shown = true;
      sessionStorage.setItem('pmb_lead_prompt_seen', '1');
      dialog.showModal();
    };
    const delay = Number(section.dataset.delay) || 20000;
    const scrollTarget = Number(section.dataset.scroll) || 40;
    const timer = window.setTimeout(show, delay);
    const onScroll = () => {
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (documentHeight > 0 && (window.scrollY / documentHeight) * 100 >= scrollTarget) {
        window.clearTimeout(timer);
        show();
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    dialog.querySelector('[data-lead-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["generated-gallery"] && !Shopify.designMode) return;
  try {
    
  class GeneratedGalleryLoop extends HTMLElement {
    connectedCallback() {
      const section = this.closest('.generated-gallery');
      const button = section?.querySelector('[data-generated-gallery-toggle]');
      if (!button) return;
      button.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.querySelector('[data-pause-label]').hidden = paused;
        button.querySelector('[data-play-label]').hidden = !paused;
      });
    }
  }

  if (!customElements.get('generated-gallery-loop')) customElements.define('generated-gallery-loop', GeneratedGalleryLoop);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('catalog-collection')) {
    customElements.define('catalog-collection', class extends HTMLElement {
      connectedCallback() {
        const search = this.querySelector('[data-catalog-search]');
        const cards = [...this.querySelectorAll('[data-product-card]')];
        const empty = this.querySelector('[data-catalog-empty]');
        search?.addEventListener('input', () => {
          const query = search.value.trim().toLowerCase();
          let visible = 0;
          cards.forEach((card) => {
            const matches = !query || card.dataset.searchText.includes(query);
            card.hidden = !matches;
            if (matches) visible += 1;
          });
          if (empty) empty.hidden = visible > 0;
        });
        this.querySelector('[data-sort-select]')?.addEventListener('change', (event) => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', event.target.value);
          window.location.assign(url.toString());
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-campaign-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-campaign-gallery')) {
    customElements.define('product-campaign-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-campaign-track]');
        this.cards = [...this.querySelectorAll('[data-campaign-card]')];
        if (!this.track) return;
        const updateProgress = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const ratio = max > 0 ? this.track.scrollLeft / max : 1;
          const bar = this.querySelector('[data-campaign-progress]');
          if (bar) bar.style.transform = `scaleX(${Math.max(0, Math.min(1, ratio))})`;
        };
        const move = (direction) => {
          const cardWidth = this.cards[0]?.getBoundingClientRect().width || this.track.clientWidth * .8;
          this.track.scrollBy({ left: direction * (cardWidth + 24), behavior: 'smooth' });
        };
        this.querySelector('[data-campaign-previous]')?.addEventListener('click', () => move(-1));
        this.querySelector('[data-campaign-next]')?.addEventListener('click', () => move(1));
        this.track.addEventListener('scroll', updateProgress, { passive: true });
        let startX = 0;
        let startScroll = 0;
        let activePointer = null;
        let dragging = false;
        this.track.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0 || event.target.closest('button, a, input, select, textarea, video, model-viewer')) return;
          activePointer = event.pointerId;
          startX = event.clientX;
          startScroll = this.track.scrollLeft;
          this.track.setPointerCapture(event.pointerId);
          if (event.pointerType !== 'touch') event.preventDefault();
        });
        this.track.addEventListener('pointermove', (event) => {
          if (event.pointerId !== activePointer) return;
          const distance = event.clientX - startX;
          if (!dragging && Math.abs(distance) > 4) {
            dragging = true;
            this.track.classList.add('is-dragging');
          }
          if (!dragging) return;
          this.track.scrollLeft = startScroll - distance;
          if (event.cancelable) event.preventDefault();
        }, { passive: false });
        const stop = (event) => {
          if (event?.pointerId != null && event.pointerId !== activePointer) return;
          const pointerToRelease = activePointer;
          activePointer = null;
          if (pointerToRelease != null && this.track.hasPointerCapture(pointerToRelease)) this.track.releasePointerCapture(pointerToRelease);
          dragging = false;
          this.track.classList.remove('is-dragging');
          updateProgress();
        };
        this.track.addEventListener('pointerup', stop);
        this.track.addEventListener('pointercancel', stop);
        this.track.addEventListener('lostpointercapture', stop);
        this.track.addEventListener('dragstart', (event) => event.preventDefault());
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => entry.target.classList.toggle('is-visible', entry.isIntersecting)), { root: this.track, threshold: .38 });
        this.cards.forEach((card) => observer.observe(card));
        updateProgress();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"]) return;
  try {
    
  if (!customElements.get('prompt-pack-product')) {
    customElements.define('prompt-pack-product', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-media-target]')];
        this.activeIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.goTo = (index) => {
          if (!this.slides.length) return;
          this.activeIndex = (index + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, slideIndex) => {
            const active = slideIndex === this.activeIndex;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
            slide.style.opacity = active ? '1' : '0';
            slide.style.visibility = active ? 'visible' : 'hidden';
            slide.style.transform = active ? 'scale(1) translateX(0)' : 'scale(1.035) translateX(1.5%)';
            if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
          });
          this.thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === this.activeIndex));
          const current = this.querySelector('[data-gallery-current]');
          if (current) current.textContent = String(this.activeIndex + 1).padStart(2, '0');
          this.thumbs[this.activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        };
        this.goTo(this.activeIndex);
        this.thumbs.forEach((button, index) => button.addEventListener('click', () => this.goTo(index)));
        this.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.goTo(this.activeIndex + 1));
        const stage = this.querySelector('[data-gallery-stage]');
        let pointerStart = 0;
        let activePointer = null;
        let dragging = false;
        let wheelLocked = false;
        stage?.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0 || event.target.closest('button, a, input, select, textarea, video, model-viewer')) return;
          activePointer = event.pointerId;
          pointerStart = event.clientX;
          stage.setPointerCapture(event.pointerId);
          if (event.pointerType !== 'touch') event.preventDefault();
        });
        stage?.addEventListener('pointermove', (event) => {
          if (event.pointerId !== activePointer) return;
          const distance = event.clientX - pointerStart;
          if (!dragging && Math.abs(distance) > 4) {
            dragging = true;
            stage.classList.add('is-dragging');
          }
          if (dragging && event.cancelable) event.preventDefault();
        }, { passive: false });
        const finishDrag = (event) => {
          if (event?.pointerId != null && event.pointerId !== activePointer) return;
          const distance = event?.clientX != null ? event.clientX - pointerStart : 0;
          const pointerToRelease = activePointer;
          activePointer = null;
          if (pointerToRelease != null && stage.hasPointerCapture(pointerToRelease)) stage.releasePointerCapture(pointerToRelease);
          stage.classList.remove('is-dragging');
          if (dragging && Math.abs(distance) > 45) this.goTo(this.activeIndex + (distance < 0 ? 1 : -1));
          dragging = false;
        };
        stage?.addEventListener('pointerup', finishDrag);
        stage?.addEventListener('pointercancel', finishDrag);
        stage?.addEventListener('lostpointercapture', finishDrag);
        stage?.addEventListener('dragstart', (event) => event.preventDefault());
        stage?.addEventListener('wheel', (event) => {
          if (wheelLocked || Math.abs(event.deltaX) < 18 || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
          event.preventDefault();
          wheelLocked = true;
          this.goTo(this.activeIndex + (event.deltaX > 0 ? 1 : -1));
          window.setTimeout(() => { wheelLocked = false; }, 420);
        }, { passive: false });
        stage?.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.goTo(this.activeIndex - 1);
          if (event.key === 'ArrowRight') this.goTo(this.activeIndex + 1);
        });
        this.querySelectorAll('input[name="id"]').forEach((input) => input.addEventListener('change', () => {
          this.querySelectorAll('.prompt-product__variant').forEach((label) => label.classList.toggle('is-selected', label.contains(input)));
          this.querySelectorAll('[data-product-price], [data-buy-price], [data-mobile-price]').forEach((price) => { price.textContent = input.dataset.price; });
        }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-inclusion-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-inclusion-gallery')) {
    customElements.define('product-inclusion-gallery', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-inclusion-tab]')];
        this.panels = [...this.querySelectorAll('[data-inclusion-panel]')];
        this.panels.forEach((panel) => [...panel.querySelectorAll('li')].forEach((item, index) => item.style.setProperty('--item-index', index)));
        this.tabs.forEach((tab) => tab.addEventListener('click', () => {
          const key = tab.dataset.inclusionTab;
          this.tabs.forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          this.panels.forEach((panel) => {
            const active = panel.dataset.inclusionPanel === key;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          });
          const label = this.querySelector('[data-inclusion-label]');
          if (label) label.textContent = tab.textContent.trim();
        }));
        const visual = this.querySelector('[data-inclusion-visual]');
        if (visual) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => visual.classList.toggle('is-revealed', entry.isIntersecting));
          }, { threshold: .42 });
          observer.observe(visual);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-gallery-loop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('loop-gallery')) {
    customElements.define('loop-gallery', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('[data-loop-toggle]');
        button?.addEventListener('click', () => {
          const paused = this.classList.toggle('is-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-footer"]) return;
  try {
    
  document.querySelectorAll('[data-footer-localization]').forEach((select) => select.addEventListener('change', () => select.form.submit()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  if (!customElements.get('store-header')) {
    customElements.define('store-header', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-localization-select]').forEach((select) => select.addEventListener('change', () => select.form.submit()));
        this.querySelectorAll('.site-header__dropdown').forEach((details) => details.addEventListener('toggle', () => {
          if (!details.open) return;
          this.querySelectorAll('.site-header__dropdown').forEach((other) => { if (other !== details) other.removeAttribute('open'); });
        }));
        const mega = this.querySelector('[data-mega-menu]');
        if (mega) {
          let closeTimer;
          const open = () => { window.clearTimeout(closeTimer); mega.open = true; };
          const close = () => { closeTimer = window.setTimeout(() => { mega.open = false; }, 140); };
          mega.addEventListener('mouseenter', open);
          mega.addEventListener('mouseleave', close);
          mega.querySelectorAll('[data-mega-tab]').forEach((tab) => {
            const activate = () => {
              mega.querySelectorAll('[data-mega-tab]').forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
              mega.querySelectorAll('[data-mega-panel]').forEach((panel) => { panel.hidden = panel.dataset.megaPanel !== tab.dataset.megaTab; });
            };
            tab.addEventListener('mouseenter', activate);
            tab.addEventListener('click', activate);
          });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
